var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { getTrackingConsentLevel, setTrackingConsentLevel } from '@anwb/browser';
import { ButtonSmall } from '@anwb/button';
import { VideoConsent, VideoConsentIcon, VideoConsentLink, VideoConsentText, VideoContainer, VideoIframe, } from './styles/video.styled';
const Video = (_a) => {
    var { className, id, title, class: reactClassName } = _a, props = __rest(_a, ["className", "id", "title", "class"]);
    const [consent, setConsent] = useState(getTrackingConsentLevel() === 3);
    useEffect(() => {
        const handleMessage = ({ data, detail, }) => {
            /*
                To handle messages passed through both window.postMessage from an iframe,
                which carries "data", and window.dispatchEvent,
                which carries "detail", we accept either.
            */
            const messageData = data || detail;
            if ((messageData === null || messageData === void 0 ? void 0 : messageData.name) === 'trackingConsentLevel') {
                setConsent(messageData.value === 3);
            }
        };
        if (typeof window !== 'undefined')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.addEventListener('trackingConsentLevel', handleMessage);
        return () => {
            if (typeof window !== 'undefined')
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                window.removeEventListener('trackingConsentLevel', handleMessage);
        };
    }, []);
    const handleGiveVideoConsent = () => {
        setConsent(setTrackingConsentLevel() === 3);
        const event = new CustomEvent('trackingConsentLevel', {
            detail: { name: 'trackingConsentLevel', value: getTrackingConsentLevel() },
        });
        window.dispatchEvent(event);
    };
    const videoClassNames = classNames('PONCHO-video', className || reactClassName);
    return (React.createElement(VideoContainer, Object.assign({ className: videoClassNames }, props),
        consent && (React.createElement(VideoIframe, { title: title, allowFullScreen: props.allowFullScreen || false, sandbox: "allow-scripts allow-same-origin allow-presentation", src: `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&modestbranding=1&controls=1` })),
        !consent && (React.createElement(VideoConsent, { className: "PONCHO-video__consent-message" },
            React.createElement(VideoConsentIcon, { className: "PONCHO-video__consent-icon" }),
            React.createElement(VideoConsentText, { className: "PONCHO-video__consent-body" },
                "Let op: als je deze externe inhoud wilt bekijken kunnen er cookies geplaatst worden.",
                ' ',
                React.createElement(VideoConsentLink, { className: "PONCHO-video__consent-link", href: "/uw-privacy", target: "_blank", rel: "noopener" }, "Meer over privacy-instellingen")),
            React.createElement(ButtonSmall, { color: "tertiary", onClick: handleGiveVideoConsent }, "Bekijk inhoud")))));
};
export default Video;
//# sourceMappingURL=Video.js.map